//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoCadastroResource from '../../common/resources/configuracao/configuracao-cadastro';

export default {
  name: 'ConfiguracaoCadastro',
  data() {
    return {
      configuracaoCadastroResource: configuracaoCadastroResource(this.$resource),
      configuracoes: [],
      sapVisible: true,
    };
  },
  components: {},
  methods: {
    requestPopular() {
      this.configuracaoCadastroResource.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.configuracoes = objeto.map((el) => {
            el.valorParametro = el.valorParametro === 'true';
            return el;
          });
        });
    },
    requestAtualizar(objeto) {
      const payload = Object.assign({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoCadastroResource.atualizar(payload)
      .then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
  },
  mounted() {
    this.requestPopular();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoCadastro.vue?vue&type=script&lang=js&